import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import BLDWebsiteUser from "./BLDWebsiteTabsContent/BLDWebsiteUser";
import BLDWebsiteIncome from "./BLDWebsiteTabsContent/BLDWebsiteIncome";
import BLDWebsitePerformance from "./BLDWebsiteTabsContent/BLDWebsitePerformance";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

const BLDWebsiteTabs = ({ sortConfig }: any) => {
  const tabs = ["user", "income", "performance"];
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get("tabOfWebsite");
  const initialTabIndex = tabs.indexOf(tabFromUrl || "user");
  const [value, setValue] = React.useState(
    initialTabIndex === -1 ? 0 : initialTabIndex,
  );
  const { websiteData } = useSelector(
    (state: any) => state.businessLeaderDashBoard,
  );

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    const newParams = new URLSearchParams(searchParams);
    newParams.set("tabOfWebsite", tabs[newValue]);
    setSearchParams(newParams);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    value: number;
    index: number;
  }

  function TabPanel({ children, value, index }: TabPanelProps) {
    return (
      <div hidden={value !== index}>
        {value === index && <Box sx={{ pt: 1 }}>{children}</Box>}
      </div>
    );
  }

  const sortedData = React.useMemo(() => {
    const filteredData = websiteData?.query_output || [];
    if (!sortConfig.field) return filteredData;
    const field = sortConfig.field;
    const getDateValue = (item: any) =>
      new Date(item.start_of_week || item.date || item.month).getTime();
    return [...filteredData].sort((a: any, b: any) => {
      if (field === "Date") {
        const aDate = getDateValue(a);
        const bDate = getDateValue(b);
        return sortConfig.direction === "asc" ? aDate - bDate : bDate - aDate;
      }
      const aVal = a[field];
      const bVal = b[field];
      if (aVal == null) return 1;
      if (bVal == null) return -1;
      if (typeof aVal === "string") {
        return sortConfig.direction === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      return sortConfig.direction === "asc" ? aVal - bVal : bVal - aVal;
    });
  }, [websiteData, sortConfig]);

  return (
    <>
      <Tabs
        value={value}
        data-tracker="674"
        onChange={handleChange}
        centered
        sx={{
          "& .MuiTabs-scrollButtons": {
            color: colors.GrayDarkMode[700].$value,
          },
          background: colors.GrayLightMode[100].$value,
          borderTop: "3px solid" + colors.GrayLightMode[100].$value,
          borderBottom: "3px solid" + colors.GrayLightMode[100].$value,
          borderRadius: spacing.Radius.md.$value,
          minHeight: spacing.Spacing["3xl"].$value,
        }}
        TabIndicatorProps={{
          sx: {
            height: spacing.Spacing.none.$value,
          },
        }}
      >
        {["User", "Income", "Performance"].map((label) => (
          <Tab
            key={label}
            label={label}
            disableRipple
            sx={{
              width: "32.8%",
              color: colors.GrayDarkMode[500].$value,
              textTransform: "none",
              fontWeight: typography.Font_weight.Regular.$value,
              borderRadius: spacing.Radius.xs.$value,
              fontSize: typography.Size.Text.xs.$value,
              lineHeight: typography.Line_height.text.xs.$value,
              padding: 0,
              minHeight: spacing.Spacing["3xl"].$value,
              "&.Mui-selected": {
                color: colors.GrayDarkMode[900].$value,
                fontWeight: typography.Font_weight.Bold.$value,
                backgroundColor: colors.Base.White.$value + "!important",
              },
              "&:hover": { backgroundColor: "transparent" },
            }}
          />
        ))}
      </Tabs>

      {/* 🔽 TAB CONTENTS */}
      <TabPanel value={value} index={0}>
        <BLDWebsiteUser sortedData={sortedData} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <BLDWebsiteIncome sortedData={sortedData} />
      </TabPanel>

      <TabPanel value={value} index={2}>
        <BLDWebsitePerformance sortedData={sortedData} />
      </TabPanel>
    </>
  );
};

export default BLDWebsiteTabs;
